<template>
  <div class=" bg-white border-b-2 border-gray-100  shadow-md">
    <vue-navigation-bar class="container max-w-6xl"  :options="navbarOptions" @vnb-item-clicked="vnbItemClicked" />
  </div>
</template>

<script>
import brandImage from '@/assets/default_main/logo.png'
import icon from '@/assets/default_main/company.svg'
import icon_que from '@/assets/default_main/question.svg'
import icon_sup from '@/assets/default_main/support.svg'
import icon_blog from '@/assets/default_main/img_blog.svg'

export default {
    data() {
      return {
        navbarOptions: {
          elementId: "main-navbar",
          isUsingVueRouter: true,
          mobileBreakpoint: 992,
          brandImagePath: "./",
          brandImage,
          brandImageAltText: "brand-image",
          collapseButtonOpenColor: "#F1674A",
          collapseButtonCloseColor: "#F1674A",
          showBrandImageInMobilePopup: true,
          ariaLabelMainNav: "Main Navigation",
          tooltipAnimationType: "shift-away",
          tooltipPlacement: "bottom",
          menuOptionsLeft: [
            // {
            //   type: "link",
            //   text: "Pricing",
            //   path: { name: "pricing"},
            //   iconRight: '<i class="fa fa-long-arrow-right fa-fw"></i>',
            // },
          ],
          menuOptionsRight: [
            // {
            //   type: "button",
            //   text: "Trang chủ",
            //   path: { name: "signup" },
            //   isLinkAction: true,
            //   // class: "button-red"
            // },
            {
              type: "button",
              text: "Giới thiệu",
              path: { name: "login" },
              isLinkAction: true,
              iconLeft: '<img alt="company image" class="max-h-6 inline-block" src="'+ icon +'" >'
            },
            {
              type: "button",
              text: "Blog",
              path: { name: "signup" },
              isLinkAction: true,
              iconLeft: '<img alt="company image" class="max-h-6 inline-block" src="'+ icon_blog +'" >'
              // class: "button-red"
            },
            {
              type: "button",
              text: "Hỏi đáp",
              path: { name: "signup" },
              isLinkAction: true,
              iconLeft: '<img alt="company image" class="max-h-6 inline-block" src="'+ icon_que +'" >'
              // class: "button-red"
            },
            {
              type: "button",
              text: "Liên hệ",
              path: { name: "signup" },
              isLinkAction: true,
              iconLeft: '<img alt="company image" class="max-h-6 inline-block" src="'+ icon_sup +'" >'
              // class: "button-red"
            },
          ]
        }
      }
    },
    methods: {
      vnbItemClicked(text) {
        console.log(text);
        if (text === "Trang chủ" || text === 'brand-image') {
          console.log("'Trang chủ' was selected.");
          // const element = document.getElementById("footer");
          // element.scrollIntoView({
          //   behavior: "smooth"
          // });
          window.location.href = 'https://vclick.vn/'

        } else if(text === 'Giới thiệu') {
          this.$bvModal.show('bv-modal-introduce')
        } else if(text === 'Blog') {
          window.location.href = 'https://vclick.vn/blog/'
        } else if(text === 'Hỏi đáp') {
          this.$bvModal.show('bv-modal-question')
        } else if(text === 'Liên hệ') {
          window.location.href = 'tel:1900633337'
        }

      }
    },
}
</script>

<style lang="scss">
  .vnb {
    background: none !important;
    .button-red {
      background: #ff3b30;

      &:hover {
        background: darken(#ff3b30, 10%);
      }
    }
  }

  .vnb__popup {
    // background: #ef4444 !important;

    //background: linear-gradient(to left, red 50%, blue 50%) right !important;
    //background-size: 200% 100%;
    
    border-radius: 10px;
    // --tw-gradient-to: #fca5a5 !important;
    // --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(239, 68, 68, 0)) !important;
    // --tw-gradient-from: #9c27b0 !important;
    // background-image: linear-gradient(to right, var(--tw-gradient-stops)) !important;
  }
  .vnb__popup__bottom {
    //background: #ef4444 !important;
    // --tw-gradient-to: #fca5a5 !important;
    // --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(239, 68, 68, 0)) !important;
    // --tw-gradient-from: #9c27b0 !important;
    // background-image: linear-gradient(to right, var(--tw-gradient-stops)) !important;
  }

  .vnb__popup__top__close-button {
    position: absolute;
    top: 20px !important;
    /* right: 10px; */
    cursor: pointer;
    right: -30px !important;
    border: 0;
    background: transparent;
  }

  .vnb__popup__bottom__menu-options__option__link{
    border-left: none !important;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    color: #34404B !important;
    font-weight: bold !important;
    cursor: pointer;
  }

  .vnb__popup__bottom__menu-options__option__link:hover {
    color: #ef4444 !important;
    background: white;
  }

  .vnb__popup__bottom__menu-options__option:not(:last-child) {
    margin-bottom: 0px !important;
  }

  .vnb-button {
   background: none !important;
  }

  .vnb__menu-options__option__button{
    font-weight: bold !important;
    border-radius: 0.75rem !important;
    color:#F1674A !important;
  }

  .vnb-button:hover {
    cursor: pointer;
    background-color: rgba(238, 167, 155, 0.3) !important;
    // opacity: 0.7;
  }

  .vnb__popup__bottom__menu-options__option__link__icon--left {
      margin-right: 5px;
      margin-top: -3px;
  }
  .vnb__collapse-button__image {
    max-height: 26px !important;
    max-width: 26px !important;
}

</style>